import { renderLocationDetails } from '@/features/Scan/utils';

const LocationUpdateActionCard = ({ locationUpdateResponse, onUndoLocationUpdate, onShowLocationModal }) => {
	return (
		<div className="folder-column-card-view mb-12 border">
			<div>
				{locationUpdateResponse && (
					<span className={`status mb-1 ${locationUpdateResponse?.isFound ? 'green-3' : 'red-2'}`}>
						{locationUpdateResponse?.isFound ? 'Location moved to' : 'Location not found'}
					</span>
				)}
				{locationUpdateResponse && (
					<p className="regular-14 gray_dark_02 mt-1">
						{locationUpdateResponse?.countryResponse?.code}
						{renderLocationDetails(locationUpdateResponse, 'buildingTagResponse')}
						{renderLocationDetails(locationUpdateResponse, 'floorTagResponse')}
						{renderLocationDetails(locationUpdateResponse, 'roomOrAreaTagResponse')}
						{renderLocationDetails(locationUpdateResponse, 'colorTagResponse')}
					</p>
				)}
				<p className="regular-12 gray_dark_02 mt-2">
					Location ID:{' '}
					<span className="gray_dark_01 weight-700"> {locationUpdateResponse?.locationId}</span>
				</p>
				<p className="blue cursor-pointer regular-14 mt-2" onClick={() => onShowLocationModal(true)}>
					{locationUpdateResponse?.isFound ? 'Edit' : 'Add this new location'}
				</p>

				{locationUpdateResponse?.isFound && (
					<div className="undo-btn d-block mt-2">
						<button className="button size32 outline" onClick={onUndoLocationUpdate}>
							Undo
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default LocationUpdateActionCard;
